// client/src/api/profile.js
// Minimal, client-side persistence fallback.
// If you later add server endpoints, you can swap these bodies to call your API.

const KEY = "profile:lastSaved";

export async function getProfile(userId) {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

export async function saveProfile(profile, userId) {
  try {
    localStorage.setItem(KEY, JSON.stringify(profile || {}));
    return { ok: true };
  } catch (e) {
    return { ok: false, error: String(e?.message || e) };
  }
}
